<template>
  <div>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    <title-bar :title-stack="titleStack" />
    <div class="card">
      <card-header
        :title="pageTitle"
        :route="`FormDispositivos?${$util.formatQueryUrl($route.query)}`"
      />
      <filter-dispositivos
        @filtrar="handleFilter"
        @limpar-filtros="handleLimparFiltros"
      />
      <section class="section is-main-section">
        <card-component class="has-table has-mobile-sort-spaced">
          <b-table
            :checked-rows.sync="checkedRows"
            :data="processedDispositivo"
            striped
            hoverable
          >
            <b-table-column v-slot="props" label="Nome" field="Nome" sortable>
              <span
                v-if="props.row.tipoAcessoDispositivo === 'CORPORATIVO'"
                class="has-text-grey is-italic"
              >
                Cadastro de Empresa
              </span>
              <span v-else>
                {{ props.row.nomePessoa || props.row.empresa }}
              </span>
            </b-table-column>

            <b-table-column
              v-slot="props"
              label="Empresa"
              field="Empresa"
              sortable
            >
              {{ props.row.empresa }}
            </b-table-column>
            <b-table-column
              v-slot="props"
              label="Tipo de Dispositivo"
              field="Tipo de Dispositivo"
              sortable
            >
              {{ props.row.tipo }}
            </b-table-column>
            <b-table-column v-slot="props" label="Marca" field="marca" sortable>
              {{ props.row.marca }}
            </b-table-column>
            <b-table-column
              v-slot="props"
              label="Modelo"
              field="modelo"
              sortable
            >
              {{ props.row.modelo }}
            </b-table-column>
            <b-table-column v-slot="props" label="Cor" field="Cor" sortable>
              {{ props.row.cor }}
            </b-table-column>
            <b-table-column field="status" label="Status">
              <template slot-scope="props">
                <StatusTag :status="props.row.status" />
              </template>
            </b-table-column>
            <b-table-column
              v-slot="props"
              label="Ações"
              cell-class="is-actions-cell"
              centered
            >
              <action-buttons
                :item="props.row"
                :showDelete="false"
                :to-config="{
                  name: 'FormDispositivos.edit',
                  params: { id: props.row.id },
                  query: { area: $route.query.area },
                }"
                @status-change="
                  (state) => atualizarStatus(state.item, state.status)
                "
              />
            </b-table-column>
            <template #empty>
              <empty-state />
            </template>
          </b-table>
          <pagination-section
            :current-page="pageable.current"
            :total-items="totalElements"
            :per-page="15"
            :current-query="$route.query"
            @page-change="handlePageChange"
          />
        </card-component>
      </section>
    </div>
  </div>
</template>

<script>
import storage from "@/mixins/storage";

import CardHeader from "@/components/Cards/CardHeader.vue";
import EmptyState from "@/components/EmptyState.vue";
import PaginationSection from "@/components/PaginationSection.vue";
import StatusTag from "@/components/StatusTag.vue";
import { defineComponent } from "vue";
import titleBar from "@/components/TitleBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import FilterDispositivos from "@/components/Filters/FilterDispositivos.vue";
import ActionButtons from "@/components/ActionButtons.vue";
import DispositivosService from "@/services/DispositivosService";

export default defineComponent({
  name: "ListDispositivos",
  components: {
    titleBar,
    CardComponent,
    FilterDispositivos,
    CardHeader,
    StatusTag,
    ActionButtons,
    EmptyState,
    PaginationSection,
  },
  data() {
    return {
      titleStack: ["SECAPI", "Dispositivos", "Listar Dispositivos"],
      veiculos: [],
      pageable: {
        current: 1,
        size: 0,
      },
      totalElements: 0,
      checkedRows: [],
      isLoading: false,

      dispositivos: [],
    };
  },
  mixins: [storage],
  computed: {
    processedDispositivo() {
      return this.dispositivos.map((dispositivo) => ({
        id: dispositivo.id,
        nomePessoa: dispositivo.nomePessoa, // ajustado pra bater com a coluna "Nome"
        empresa: dispositivo.nomeEmpresa,
        tipo: dispositivo.tipoDispositivo, // <-- precisa confirmar o nome real do campo (ver abaixo)
        marca: dispositivo.marca,
        modelo: dispositivo.modelo,
        cor: dispositivo.cor,
        status: dispositivo.status,
      }));
    },
    pageTitle() {
      return "Listar Dispositivos";
    },
    currentRoute() {
      return this.$route;
    },
  },
  watch: {
    "$route.query": {
      immediate: true,
      async handler(query) {
        this.pageable.current = parseInt(query.page) || 1;
        await this.fetchData();
      },
    },
  },
  methods: {
    async fetchData() {
      try {
        const response = await DispositivosService.getDispositivos(
          this.pageable.current - 1,
          this.$util.formatQueryUrl(this.currentRoute.query)
        );
        this.dispositivos = response.data.content;
        this.totalElements = response.data.totalElements;
        this.pageable.size = response.data.totalElements;
      } catch (error) {
        this.handleError(error, "Erro ao carregar dispositivos");
      }
    },
    handlePageChange(newPage) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: newPage,
        },
      });
    },
    handleFilter(filtro) {
      const newQuery = {
        ...this.currentRoute.query,
        ...filtro,
        page: 1,
      };
      this.$router.push({ query: newQuery });
    },
    handleLimparFiltros() {
      this.$router.replace({
        query: {
          area: this.$route.query.area,
        },
      });
    },
    handleError(error, message) {
      this.$buefy.toast.open({
        message: message,
        type: "is-danger",
        position: "is-bottom",
      });
      console.error(error);
    },
  },
});
</script>
